<div class="flex-1 w-full h-full flex glass-effect bg-red-300 rounded-4xl relative">
    <div class="absolute 2xl:w-14 2xl:h-14 xl:w-12 xl:h-12 w-10 h-10 bg-white rounded-full flex items-center justify-center top-44 2xl:-end-7 xl:-end-6 -end-5">
        <img [src]="promoCards[promoCardIndex].images.promoCardIcon1Img" alt="Promo Card" class="2xl:w-8 2xl:h-8 xl:w-6 xl:h-6 w-4 h-4">
    </div>
    <div class="absolute 2xl:w-14 2xl:h-14 xl:w-12 xl:h-12 w-10 h-10 lg bg-white rounded-full flex items-center justify-center bottom-28 2xl:-start-7 xl:-start-6 -start-5">
        <img [src]="promoCards[promoCardIndex].images.promoCardIcon2Img" alt="Promo Card" class="2xl:w-8 2xl:h-8 xl:w-6 xl:h-6 w-4 h-4">
    </div>

    <div class="absolute flex items-center justify-center bottom-20 start-12 gap-0.5">
      <button *ngFor="let card of promoCards; let i = index" (click)="goToSlide(i)" class="transition-all duration-300 rounded-full cursor-pointer"
        [class]="i === promoCardIndex ? 'w-6 h-2 bg-white' : 'w-2 h-2 bg-white/50'"
      ></button>
    </div>

    <div class="w-full h-full flex flex-col justify-between overflow-y-hidden px-4 pt-4">
        <div class="w-full flex flex-col items-start gap-4 px-12 pt-4">
            <img src="shared/text_logo.svg" alt="Promo Card" class="w-[85px]">
            <p dir="auto" [@fadeSlider]="promoCardIndex" class="text-white font-semibold  xl:text-[1.5vw] lg:text-[1.55vw] text-[3.5vw] text-start">{{ promoCards[promoCardIndex].title | translate }}</p>
        </div>
        <div [@fadeSlider]="promoCardIndex" class="flex md:justify-center lg:justify-end">
            <img [src]="promoCards[promoCardIndex].images.promoCardPersonImg" alt="Promo Card" class="md:w-[300px] lg:w-4/5">
        </div>
    </div>

</div>
